module.exports = __webpack_public_path__ + "static/media/share.cd14f2a7.svg";